import React from "react";
import { useGoogleLogin } from '@react-oauth/google';

import { authenticationService } from "../../../../jwt/_services";
import { useLocation, useHistory } from "react-router-dom";

import GoogleLogoSvg from "../../../../assets/images/google-logo.svg"

import "./google.css";

const GoogleLogin = ({setAuthError, setAuthErrorMsg, isDisabled = false}) => {

    const location = useLocation();
    const history = useHistory();

    const { from } = location.state || { from: { pathname: "/" } }

    const googleLogin = useGoogleLogin({
        flow: "auth-code",
        onSuccess: async (codeResponse) => {
            let authCode = codeResponse.code;
            authenticationService.socialAuth("google-oauth2", authCode, "postmessage", "login").then(
                user => {
                    history.push(from);
                },
                error => {
                    console.log("Error in login with Google");
                    let errorMsg = "Error in login with Google";
                    if(error && error.message)
                    {
                        errorMsg = error.message;
                    }
                    console.log(errorMsg);
                    setAuthErrorMsg(errorMsg);
                    setAuthError(true);
                }
            );
        },
        onError: (errorResponse) => {
            console.log("Error in login with Google");
            console.log(errorResponse);
            setAuthErrorMsg("Error in login with Google");
            setAuthError(true);
        },
    });


  return (
    <>
        <span
            className={"google-btn " + (isDisabled ? "disabled" : "")}
            disabled={isDisabled}
            onClick={() => {
                if(isDisabled) return;
                setAuthError(false);
                setAuthErrorMsg("");
                googleLogin();
            }}
        >
            <img width="20px" height="100%" style={{marginBottom: '3px', marginRight: '16px'}} alt="Google login" src={GoogleLogoSvg} />
            SIGN IN WITH GOOGLE
        </span>
    </>
  );
};


export default GoogleLogin;